import { createContext, useContext } from "react";

export {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useNavigationType,
  useParams,
  useSearchParams,
} from "react-router-dom";

const OutletContext = createContext(null);

export function OutletProvider({ children, outlet }) {
  return <OutletContext.Provider value={outlet}>{children}</OutletContext.Provider>;
}

export function Outlet() {
  return useContext(OutletContext);
}
